import React from "react";
import { IconProps } from "./IconProps";

const CalendarTodayIcon: React.FC<IconProps> = ({
  width = 18,
  height = 18,
  color = "#0F5051",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none">
      <path
        d="M15 2.25H14.25V1.5C14.25 1.0875 13.9125 0.75 13.5 0.75C13.0875 0.75 12.75 1.0875 12.75 1.5V2.25H5.25V1.5C5.25 1.0875 4.9125 0.75 4.5 0.75C4.0875 0.75 3.75 1.0875 3.75 1.5V2.25H3C2.175 2.25 1.5 2.925 1.5 3.75V15.75C1.5 16.575 2.175 17.25 3 17.25H15C15.825 17.25 16.5 16.575 16.5 15.75V3.75C16.5 2.925 15.825 2.25 15 2.25ZM14.25 15.75H3.75C3.3375 15.75 3 15.4125 3 15V6H15V15C15 15.4125 14.6625 15.75 14.25 15.75Z"
        fill={color}
      />
    </svg>
  );
};
export default CalendarTodayIcon;
